import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { LOGO_LG } from "@assets";
import { useNavigate } from "react-router";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { LIMITS } from "@constants";
import { useSelector } from "react-redux";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: linear-gradient(
    10.7deg,
    #a66b10 2.44%,
    #f8ca53 29.45%,
    #d99632 52.26%,
    #f8ca53 70.27%,
    #ffb930 81.07%,
    #f9a72c 92.06%
  );
`;

const Image = styled.img.attrs({
  alt: "logo",
  src: LOGO_LG,
})`
  height: auto;
  object-fit: contain;
  position: relative;
`;

const Label = styled.div`
  position: absolute;
  bottom: 30px;
  color: ${(props) => props.theme.white};
  font-weight: 600;
  font-size: 16px;
`;

const Splash = () => {
  const navigate = useNavigate();
  const { splash_ads_active } = useSelector((state) => state.app.settings);
  let timer = useRef();

  useEffect(() => {
    timer.current = setTimeout(() => {
      goToNextScreen(splash_ads_active);
    }, LIMITS.SPLASH_SCREEN_TIMEOUT * 1000);

    return () => {
      clearTimeout(timer.current);
    };
    // eslint-disable-next-line
  }, [splash_ads_active]);

  const goToNextScreen = (splash_ads_active) => {
    if (splash_ads_active) {
      navigate(PUBLIC_ROUTE.ONBOARDING);
    } else {
      navigate(PUBLIC_ROUTE.LOGIN);
    }
  };

  return (
    <Container>
      <Image />
      <Label>SHWE GAMING</Label>
    </Container>
  );
};

export default Splash;
